import { Component, OnInit, output } from '@angular/core';
import {
  BudgetOptions,
  ExpenditureOptions,
} from 'src/app/core/constants-repository/project-calculation.constants';
import { cloneDeep } from 'lodash-es';
import { ProjectDataService } from '../../../state-and-data-handling/project-data.service';

@Component({
  selector: 'app-project-calculation-form',
  templateUrl: './project-calculation-form.component.html',
  standalone: false,
})
export class ProjectCalculationFormComponent implements OnInit {
  readonly selectedBudgetOptionChanged$ = output<BudgetOptions>();
  readonly selectedExpenditureRateOptionChanged$ = output<ExpenditureOptions>();
  public selectedExpenditureRateOption: ExpenditureOptions;

  constructor(private readonly projectDataService: ProjectDataService) {}

  ngOnInit(): void {
    const projectClone = this.projectDataService.getProjectClone();
    this.selectedExpenditureRateOption = projectClone.expenditureType;
  }

  public expenditureRateOptionChanged($event: ExpenditureOptions): void {
    const project = this.projectDataService.getProjectClone();
    const clonedProject = cloneDeep(project);
    this.selectedExpenditureRateOption = $event;
    clonedProject.expenditureType = this.selectedExpenditureRateOption;

    this.selectedExpenditureRateOptionChanged$.emit($event);
    this.projectDataService.updateProject(clonedProject);
    this.projectDataService.userOperationConducted$.next(true);
  }

  public budgetOptionChanged($event: BudgetOptions): void {
    const project = this.projectDataService.getProjectClone();
    const clonedProject = cloneDeep(project);
    clonedProject.budgetType = $event;

    this.selectedBudgetOptionChanged$.emit($event);
    this.projectDataService.updateProject(clonedProject);
    this.projectDataService.userOperationConducted$.next(true);
  }
}
